<template>
  <div>
    <dots-menu
      :items="dotsItems"
      is-absolute
      @paihImport="toggleDialog({ action: 'import', type: 'input' })"
      @paihExport="toggleDialog({ action: 'export', type: 'input' })"
    >
      <template #activator="{ on }">
        <base-rounded-button
          v-on="on"
          innerText="PAIH"
          size="x-small"
          color="rgba(235, 235, 235, 0.5)"
          iconColor="#202124"
          :tooltip="$i18n.t('sidebar.paihImportExport')"
        />
      </template>
    </dots-menu>
    <main-input-dialog
      v-if="isMainInputDialogLoaded"
      :is-visible.sync="isMainInputDialogVisible"
      :title-translation="$i18n.t(`dialog.paih.title${$_capitalize(action)}`)"
      :agree-text="`dialog.agree${$_capitalize(action)}`"
      :inputs="inputs"
      dialog-width="30%"
      @agree="toggleDialog({ action })"
    >
      <template v-for="input of inputs" #[`${input.name}.input`]="data">
        <v-col :key="input.name" cols="6">
          <data-input v-model="payload[input.name]" v-bind="data" />
        </v-col>
      </template>
    </main-input-dialog>
    <main-dialog
      v-if="isMainDialogLoaded"
      :is-visible.sync="isMainDialogVisible"
      :title="$i18n.t(`dialog.paih.title${$_capitalize(action)}`)"
      :body="$i18n.t(`dialog.paih.confirmation${$_capitalize(action)}`)"
      :agree-text="`dialog.agree${$_capitalize(action)}`"
      :loading="isLoading"
      @agree="dialogActionHandler()"
    />
  </div>
</template>

<script>
import { call } from 'vuex-pathify';

import DotsMenu from '@/components/DotsMenu';
import DataInput from '@/components/DataInput';

export default {
  name: 'FeatureCardPaihMigratorButton',
  components: {
    DotsMenu,
    DataInput,
    MainInputDialog: () => import('@/components/MainInputDialog'),
    MainDialog: () => import('@/components/MainDialog'),
  },
  props: {
    isEditingOn: {
      type: Boolean,
      required: true,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
    featureId: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    isMainDialogLoaded: false,
    isMainDialogVisible: false,
    isMainInputDialogLoaded: false,
    isMainInputDialogVisible: false,
    isLoading: false,
    payload: {},
    action: '',
  }),
  computed: {
    dotsItems() {
      return [
        {
          name: 'paihImport',
        },
        {
          name: 'paihExport',
          disabled: this.isEditingOn,
          tooltip: this.isEditingOn && this.$i18n.t('menu.paihExportTooltip'),
        },
      ];
    },
    inputs() {
      return ['username', 'password', 'offer_id'].map(name => {
        return {
          name,
          dataType: { name: 'text' },
          translationPath: `dialog.paih.${name}`,
          subtitle: name === 'offer_id' ? `dialog.paih.${name}${this.$_capitalize(this.action)}Subtitle` : '',
          type: name === 'password' ? 'password' : 'text',
          rules: [v => !!v || v == '0' || 'rules.required'],
          autocomplete: 'new-password',
        };
      });
    },
  },
  methods: {
    importPaihOffer: call('externalSystems/importPaihOffer'),
    exportPaihOffer: call('externalSystems/exportPaihOffer'),
    toggleDialog({ action = '', type = '', value = true } = {}) {
      this.action = action;
      this[`isMain${this.$_capitalize(type)}DialogLoaded`] = value;
      this[`isMain${this.$_capitalize(type)}DialogVisible`] = value;
    },
    async dialogActionHandler() {
      this.isLoading = true;
      try {
        if (this.action === 'import') {
          const attrs = await this.importPaihOffer(this.payload);
          this.$emit('setPaihAttributes', attrs);
        } else {
          await this.exportPaihOffer({
            ...this.payload,
            data_source_name: this.dataSourceName,
            feature_id: this.featureId,
          });
        }
      } finally {
        this.isLoading = false;
        this.payload = {};
        this.toggleDialog({ type: 'input', value: false });
        this.toggleDialog({ value: false });
      }
    },
  },
};
</script>
